goog.provide('el8.util.amplitude.reportHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Amplitude logging for annotating a report with source and report ID
 * 
 * @param {string} source - the place in the UI where annotation is initiated
 * @param {string} reportId - the ID of the report being annotated
 */
el8.util.amplitude.logAnnotateReportV2 = function(source, reportId, reportType, numPages) {
  el8.util.amplitude.logEvent('Annotate Report V2', { 'source': source, 'reportId': reportId, 'reportType': reportType, 'numPages': numPages});
};
